import { render, staticRenderFns } from "./HXContentCardComponentes.vue?vue&type=template&id=c829777a&scoped=true"
import script from "./HXContentCardComponentes.vue?vue&type=script&lang=js"
export * from "./HXContentCardComponentes.vue?vue&type=script&lang=js"
import style0 from "./HXContentCardComponentes.vue?vue&type=style&index=0&id=c829777a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c829777a",
  null
  
)

export default component.exports